import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import AuthDataService from 'src/services/auth.service'

export const useGetLogin2FAVerificationEmailTime = (userId: string | null) => {
  return useQuery([QUERY_KEYS.AUTH_USER_2FA_EMAIL_TIME], () => {
    if (!userId) {
      return
    }

    return AuthDataService.get2FAVerificationEmailTime(userId)
  })
}
